import { render } from "./news2.vue?vue&type=template&id=a7e121c4"
import script from "./news2.vue?vue&type=script&lang=js"
export * from "./news2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\thangpn\\code\\free\\frontend-amber-hills\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__